import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './ui/CtaButton';
import { modules } from '../data/content';
export function ModulesSection() {
  return <section aria-labelledby="modulos" className="bg-mist" data-id="element-113" data-mp="1it8i1ih6qi9v">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-114" data-mp="1dxtb7ahlhmmy">
        <Reveal data-id="element-115" data-mp="2bkihhwjbylem">
          <SectionHeading id="modulos" title="Qué encontrarás dentro" data-id="element-116" data-mp="2bj7alnul8xja" />
        </Reveal>

        <ol className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-117" data-mp="26kw0rd4amn12">
          {modules.map((mod, i) => <Reveal key={mod.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-navy/10 border-t-4 border-t-solar bg-white p-3" data-id="element-118" data-mp="21krm7smy42dh" data-mpi={i}>
              <h3 className="flex items-start gap-2 font-condensed text-base uppercase leading-tight tracking-wide text-navy sm:text-lg" data-id="element-119" data-mp="q4t9nesk6y7i">
                <CheckCircle2Icon size={16} className="mt-1 flex-shrink-0 text-azure" strokeWidth={2.5} data-id="element-120" data-mp="1iup6e9m7ksmr" />
                {mod.title}
              </h3>
              <p className="mt-1 font-body text-[0.76rem] leading-snug text-steel sm:text-[0.8rem]" data-id="element-121" data-mp="18w9g28v09neb">
                {mod.desc}
              </p>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} className="mt-3 flex justify-center" data-id="element-122" data-mp="103potth1ml3i">
          <CtaButton size="lg" data-id="element-123" data-mp="14v7g1pt9l7ba">
            ☀️ ¡SÍ! QUIERO APRENDER ENERGÍA SOLAR DESDE CERO
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}